import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-d241c6c2"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "rednote-page"
};
const _hoisted_2 = {
  class: "title-section"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "top-quote"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: "https://p6.moimg.net/wxapp/prize_top_title_left.png",
  alt: "引号",
  class: "quote-icon"
})], -1));
const _hoisted_4 = {
  key: 0,
  class: "activity-title"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "prize-des"
}, "抽奖码越多中奖概率越大", -1));
const _hoisted_6 = /*#__PURE__*/_createTextVNode("我的抽奖码");
const _hoisted_7 = {
  class: "prize-code"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://p6.moimg.net/wxapp/prize_detail_arrow_gray.png",
  alt: "箭头",
  class: "arrow-icon"
}, null, -1));
const _hoisted_9 = {
  class: "activity-background"
};
const _hoisted_10 = ["src"];
const _hoisted_11 = {
  class: "activity-overlay"
};
const _hoisted_12 = {
  class: "activity-heading"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "view-result-text"
}, "查看奖品", -1));
const _hoisted_14 = ["src"];
const _hoisted_15 = {
  class: "prize-card"
};
const _hoisted_16 = {
  class: "prize-display"
};
const _hoisted_17 = {
  class: "current-prize-detail"
};
const _hoisted_18 = {
  class: "prize-image-container"
};
const _hoisted_19 = ["src"];
const _hoisted_20 = {
  class: "prize-details"
};
const _hoisted_21 = {
  class: "prize-header"
};
const _hoisted_22 = {
  class: "prize-name"
};
const _hoisted_23 = {
  key: 0,
  src: "https://p6.moimg.net/mdwxapp/xhs_arrow.png",
  alt: "箭头",
  class: "detail-arrow"
};
const _hoisted_24 = {
  class: "prize-meta"
};
const _hoisted_25 = {
  class: "prize-quantity"
};
const _hoisted_26 = {
  key: 0,
  class: "prize-quantity"
};
const _hoisted_27 = {
  key: 1,
  class: "prize-tags"
};
const _hoisted_28 = {
  key: 0,
  class: "prize-price"
};
const _hoisted_29 = {
  key: 0,
  class: "prizes-bottom-list"
};
const _hoisted_30 = {
  class: "prizes-carousel"
};
const _hoisted_31 = ["onClick"];
const _hoisted_32 = {
  class: "prize-item-image"
};
const _hoisted_33 = ["src"];
const _hoisted_34 = {
  class: "prize-count-info"
};
const _hoisted_35 = {
  class: "count-text"
};
const _hoisted_36 = {
  class: "time-label"
};
const _hoisted_37 = {
  class: "time-value"
};
const _hoisted_38 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://p6.moimg.net/wxapp/prize_detail_arrow_gray.png",
  alt: "箭头",
  class: "arrow-icon"
}, null, -1));
const _hoisted_39 = {
  key: 1,
  class: "activity-time-empty"
};
const _hoisted_40 = {
  key: 0,
  class: "condition-list-section"
};
const _hoisted_41 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "condition-header"
}, [/*#__PURE__*/_createElementVNode("h3", {
  class: "condition-title"
}, "完成任务 获抽奖码")], -1));
const _hoisted_42 = {
  class: "condition-list"
};
const _hoisted_43 = {
  class: "condition-icon"
};
const _hoisted_44 = ["src"];
const _hoisted_45 = {
  class: "condition-content"
};
const _hoisted_46 = {
  class: "condition-main"
};
const _hoisted_47 = {
  key: 0,
  class: "condition-name"
};
const _hoisted_48 = {
  key: 1,
  class: "ticket-reward"
};
const _hoisted_49 = {
  key: 0,
  class: "condition-description"
};
const _hoisted_50 = {
  key: 0,
  class: "desc-main"
};
const _hoisted_51 = {
  key: 1,
  class: "desc-detail"
};
const _hoisted_52 = {
  class: "condition-action"
};
const _hoisted_53 = {
  class: "project-info-card"
};
const _hoisted_54 = {
  key: 0,
  class: "project-tag"
};
const _hoisted_55 = {
  class: "project-name"
};
const _hoisted_56 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "project-action"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "view-project"
}, "查看项目"), /*#__PURE__*/_createElementVNode("img", {
  src: "https://p6.moimg.net/wxapp/prize_detail_arrow_gray.png",
  alt: "箭头",
  class: "project-arrow-small"
})], -1));
const _hoisted_57 = {
  class: "stats-text"
};
const _hoisted_58 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://p6.moimg.net/wxapp/prize_detail_arrow_gray.png",
  alt: "箭头",
  class: "stats-arrow"
}, null, -1));
const _hoisted_59 = {
  class: "participant-avatars"
};
const _hoisted_60 = ["src"];
const _hoisted_61 = {
  key: 1,
  class: "condition-notice"
};
const _hoisted_62 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "notice-icon"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: "https://p6.moimg.net/wxapp/prize_detail_warn_icon.png",
  alt: "警告"
})], -1));
const _hoisted_63 = {
  class: "notice-text"
};
const _hoisted_64 = {
  key: 0,
  class: "fixed-bottom-bar"
};
const _hoisted_65 = {
  class: "action-button-group"
};
const _hoisted_66 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "bottom-divider"
}, null, -1));
const _hoisted_67 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "safe-area-spacer"
}, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_image = _resolveComponent("van-image");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: _normalizeClass(["main-content", {
      'has-bottom-button': $options.shouldShowBottomButton()
    }])
  }, [_createElementVNode("div", _hoisted_2, [_hoisted_3, $data.prizeModel.activity_info.title ? (_openBlock(), _createElementBlock("h1", _hoisted_4, _toDisplayString($data.prizeModel.activity_info.title), 1)) : _createCommentVNode("", true), _hoisted_5, _createElementVNode("div", {
    class: "prize-code-view",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.guideToApp && $options.guideToApp(...args))
  }, [_hoisted_6, _createElementVNode("span", _hoisted_7, _toDisplayString($data.prizeModel.activity_info.ticket_count), 1), _hoisted_8])]), _createElementVNode("div", {
    class: _normalizeClass(["rednote-activity-section", [`status-${$options.getActivityStatusType()}`]])
  }, [_createElementVNode("div", _hoisted_9, [_createElementVNode("img", {
    src: $options.getActivityBackgroundImage(),
    alt: "活动背景",
    class: "activity-bg-image"
  }, null, 8, _hoisted_10), _createElementVNode("div", _hoisted_11, [_createElementVNode("h2", _hoisted_12, _toDisplayString($options.getActivityHeadingText()), 1), $data.prizeModel.activity_info.status === 2 ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "view-result-btn",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.handleViewResult && $options.handleViewResult(...args))
  }, [_hoisted_13, _createElementVNode("img", {
    src: $options.getResultArrowImage(),
    alt: "查看结果",
    class: "result-arrow"
  }, null, 8, _hoisted_14)])) : _createCommentVNode("", true)]), _createVNode(_component_van_image, {
    class: "activity-gift-icon",
    src: $options.getActivityGiftImage()
  }, null, 8, ["src"])])], 2), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createElementVNode("div", {
    class: "prize-showcase",
    onClick: _cache[2] || (_cache[2] = $event => $options.handlePrizeClick())
  }, [_createElementVNode("div", _hoisted_18, [_createElementVNode("img", {
    src: $options.getCurrentPrize().img || '/src/assets/images/placeholder/default_1x1@2x.png',
    alt: "奖品图片",
    class: "prize-image"
  }, null, 8, _hoisted_19)]), _createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createElementVNode("h3", _hoisted_22, _toDisplayString($options.getCurrentPrize().prize_name), 1), $options.getCurrentPrize().jump_url ? (_openBlock(), _createElementBlock("img", _hoisted_23)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_24, [_createElementVNode("span", _hoisted_25, _toDisplayString($options.getCurrentPrize().num) + "个", 1), $options.getCurrentPrize().relation_type === 1 ? (_openBlock(), _createElementBlock("span", _hoisted_26, "赠品")) : _createCommentVNode("", true), $options.getCurrentPrize().relation_type === 2 ? (_openBlock(), _createElementBlock("div", _hoisted_27, "购买权")) : _createCommentVNode("", true)]), $options.getCurrentPrize().price ? (_openBlock(), _createElementBlock("div", _hoisted_28, " ¥" + _toDisplayString($options.getCurrentPrize().price), 1)) : _createCommentVNode("", true)])])]), $data.prizeModel.prize_list.length > 1 ? (_openBlock(), _createElementBlock("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.prizeModel.prize_list, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: _normalizeClass(["prize-item", {
        active: $data.selectedPrizeIndex === index
      }]),
      onClick: $event => $options.selectPrize(index)
    }, [_createElementVNode("div", _hoisted_32, [_createElementVNode("img", {
      src: item.img || '/src/assets/images/placeholder/default_1x1@2x.png',
      alt: "奖品"
    }, null, 8, _hoisted_33)])], 10, _hoisted_31);
  }), 128))]), _createElementVNode("div", _hoisted_34, [_createElementVNode("span", _hoisted_35, _toDisplayString($data.prizeModel.prize_list.length) + "款共" + _toDisplayString($options.getTotalPrizeCount()) + "个", 1)])])) : _createCommentVNode("", true)]), $data.prizeModel.activity_info.require_condition_title && $data.prizeModel.activity_info.require_condition ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "activity-time",
    onClick: _cache[3] || (_cache[3] = (...args) => $options.guideToApp && $options.guideToApp(...args))
  }, [_createElementVNode("span", _hoisted_36, _toDisplayString($data.prizeModel.activity_info.require_condition_title), 1), _createElementVNode("span", _hoisted_37, _toDisplayString($data.prizeModel.activity_info.require_condition), 1), _hoisted_38])) : (_openBlock(), _createElementBlock("div", _hoisted_39))]), $data.prizeModel.condition_list && $data.prizeModel.condition_list.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_40, [_hoisted_41, _createElementVNode("div", _hoisted_42, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.prizeModel.condition_list, (condition, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: condition.condition_id || index,
      class: _normalizeClass(["condition-item", $options.getConditionItemClass(condition.status)])
    }, [_createElementVNode("div", _hoisted_43, [condition.icon ? (_openBlock(), _createElementBlock("img", {
      key: 0,
      src: condition.icon,
      alt: "条件图标",
      class: "icon-image"
    }, null, 8, _hoisted_44)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_45, [_createElementVNode("div", _hoisted_46, [condition.title ? (_openBlock(), _createElementBlock("span", _hoisted_47, _toDisplayString(condition.title), 1)) : _createCommentVNode("", true), condition.ticket_count ? (_openBlock(), _createElementBlock("span", _hoisted_48, "抽奖码+" + _toDisplayString(condition.ticket_count), 1)) : _createCommentVNode("", true)]), condition.describe || condition.describe_val ? (_openBlock(), _createElementBlock("div", _hoisted_49, [condition.describe ? (_openBlock(), _createElementBlock("p", _hoisted_50, _toDisplayString(condition.describe), 1)) : _createCommentVNode("", true), condition.describe_val ? (_openBlock(), _createElementBlock("p", _hoisted_51, _toDisplayString(condition.describe_val || '#我是一个人畜无害的话题'), 1)) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_52, [_createElementVNode("div", {
      class: _normalizeClass(["status-button", $options.getConditionButtonClass(condition.status)]),
      onClick: _cache[4] || (_cache[4] = (...args) => $options.guideToApp && $options.guideToApp(...args))
    }, _toDisplayString(condition.button_name || $options.getConditionStatusText(condition.status)), 3)])], 2);
  }), 128))]), _createElementVNode("div", _hoisted_53, [$data.prizeModel.item_info.item_type_name ? (_openBlock(), _createElementBlock("div", _hoisted_54, _toDisplayString($data.prizeModel.item_info.item_type_name), 1)) : _createCommentVNode("", true), _createElementVNode("h4", _hoisted_55, _toDisplayString($data.prizeModel.item_info.title), 1), _hoisted_56]), $data.prizeModel.activity_info.join_number > 0 ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "participation-stats",
    onClick: _cache[5] || (_cache[5] = (...args) => $options.guideToApp && $options.guideToApp(...args))
  }, [_createElementVNode("div", _hoisted_57, [_createElementVNode("span", null, "已有" + _toDisplayString($data.prizeModel.activity_info.join_number) + "人参与，查看全部", 1), _hoisted_58]), _createElementVNode("div", _hoisted_59, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.prizeModel.activity_info.join_list.slice(0, $options.getParticipantAvatarCount()), (participant, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "avatar"
    }, [_createElementVNode("img", {
      src: participant.icon,
      alt: "参与者头像"
    }, null, 8, _hoisted_60)]);
  }), 128))])])) : _createCommentVNode("", true), $data.prizeModel.activity_info.draw_condition_tip ? (_openBlock(), _createElementBlock("div", _hoisted_61, [_hoisted_62, _createElementVNode("span", _hoisted_63, _toDisplayString($data.prizeModel.activity_info.draw_condition_tip), 1)])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)], 2), $options.shouldShowBottomButton() ? (_openBlock(), _createElementBlock("div", _hoisted_64, [_createElementVNode("div", _hoisted_65, [_createElementVNode("button", {
    class: _normalizeClass(["action-button", $options.getBottomButtonClass()]),
    onClick: _cache[6] || (_cache[6] = (...args) => $options.handleBottomButtonClick && $options.handleBottomButtonClick(...args))
  }, _toDisplayString($options.getBottomButtonText()), 3)]), _hoisted_66])) : _createCommentVNode("", true), _hoisted_67]);
}